import { Form, Input } from 'antd'
import React from 'react'
import { validateIdNumber } from '@/utils'

/**
 * 根据证件类型动态生成证件号码输入框，并在证件类型改变时（如果设置为如此）重置证件号码字段。
 * @param {Object} form - 表单对象，用于重置表单字段和获取表单值。
 * @param {string} idType - 证件类型的字段名，默认为'idType'。
 * @param {string} idCard - 证件号码的字段名，默认为'idCard'。
 * @param {boolean} idCardChangeByIdType - 当证件类型改变时是否重置证件号码字段，默认为true。
 * @param {boolean} desensitize - 是否脱敏取消校验，默认为false。
 * @param {boolean} disabled - 是否可编辑
 * @returns 返回一个封装了动态证件号码输入框的Form.Item组件。
 */

const FormItemIdCard = ({ form, idType = 'idType', idCard = 'idCard', idCardChangeByIdType = false,desensitize=false, disabled = false }) => {

  return (
    <Form.Item
      noStyle
      shouldUpdate={(prevValues, curValues) => {
        const idTypeChanged = prevValues[idType] !== curValues[idType]
        if (idTypeChanged && idCardChangeByIdType) {
          form.resetFields([idCard]) // 重置 idCard 字段
        }
        return idTypeChanged
      }}
    >
      {(({ getFieldValue }) => {
        const idTypes = getFieldValue(idType)
        return (
          <Form.Item
            name={idCard}
            label="证件号码"
            rules={[
              {
                required: true,
                pattern: validateIdNumber(idTypes,desensitize),
                message: '请输入正确的证件号码'
              }
            ]}
          >
            <Input disabled={disabled} placeholder="请输入证件号码" maxLength={18} />
          </Form.Item>
        )
      })}

    </Form.Item>
  )
}

export default FormItemIdCard
